// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__k2JIG","logo":"Navbar_logo__JkLJJ","menu":"Navbar_menu__V5+a4"};